import { combineReducers } from 'redux'
import companies from './Companies'
import products from './Products'
import credits_logs from './CreditsLogs'
import credits from './Credits'
import users from './Users'
import groups from './Groups'
import page from './Page'
import { reducer as formReducer } from 'redux-form'

const reducers = combineReducers({users, companies, products, credits, credits_logs, users, groups, page, form: formReducer})

export default reducers
